import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'react-bootstrap';

import NutrientSelect from '../common/NutrientSelect';
import GroupSelect from '../common/GroupSelect';

import 'react-bootstrap-typeahead/css/Typeahead.css';

/**
 * Concerns of this component:
 *   control values in the forms (child components)
 *   to generate and pass query when submit
**/
class SingleNutrientQueryBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: this.props.selectedComponent ? this.props.selectedComponent : [],
      group: this.props.selectedGroup || 'all',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setNutrientCode = this.setNutrientCode.bind(this);
    this.setGroup = this.setGroup.bind(this);
  }

  // to update forms when navigated via history.
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        code: nextProps.selectedComponent ? nextProps.selectedComponent : [],
        group: nextProps.selectedGroup || 'all',
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    // pass query to SingleNutrientSearch
    this.props.handleSubmit({
      code: this.state.code[0],
      group: this.state.group === 'all' ? '' : this.state.group,
    });
  }

  setNutrientCode(code) {
    // receives an array of the selected options.
    this.setState({code: code});
  }

  setGroup(group) {
    this.setState({group: group});
  }

  render() {
    const { components, groups } = this.props;
    return (
      <div className="SingleNutrientQueryBuilder">
        <p>Provides the details of the amount of each nutrient in a food.</p>

        <form onSubmit={this.handleSubmit}>
          <Col sm={12} md={6}>
            <NutrientSelect
              components={components}
              selected={this.state.code}
              label='Search for a nutrient (e.g. iron)'
              placeholder='Start typing and select from list'
              setNutrientCode={this.setNutrientCode}/>
          </Col>
          <Col sm={12} md={6}>
            <GroupSelect
              groups={groups}
              selected={this.state.group}
              setGroup={this.setGroup}/>
          </Col>
          <div className="searchButton">
            <Button type="submit" bsStyle="primary">GO</Button>
          </div>
        </form>

      </div>
    );
  }
}

SingleNutrientQueryBuilder.propTypes = {
  components: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  selectedComponent: PropTypes.array,
  selectedGroup: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default SingleNutrientQueryBuilder;



// WEBPACK FOOTER //
// ./src/components/search/singleNutrient/SingleNutrientQueryBuilder.js